import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import filterFormErrors from '@anm/helpers/form/filterFormErrors';
import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import UpgradeSubscriptionBlock, {
  UpgradeSubscriptionBlockProps
} from '../UpgradeSubscriptionBlock';

export type UpgradeSubscriptionFormFields = {
  cvc: number;
  email: string;
  coupon: string;
  number: string;
  address_zip: string;
  expiry_year: number;
  expiry_month: number;
  billingPeriod: SubscriptionPeriod;
};

export type UpgradeSubscriptionFormProps = FinalFormConfig<
  UpgradeSubscriptionFormFields
> &
  Omit<UpgradeSubscriptionBlockProps, 'formErrors' | 'onPurchase'> & {
    email?: string;
  };

const renderForm = (props: UpgradeSubscriptionFormProps) => ({
  handleSubmit,
  values: { coupon, billingPeriod },
  errors,
  touched
}: FormRenderProps<UpgradeSubscriptionFormFields>) => (
  <UpgradeSubscriptionBlock
    {...props}
    coupon={coupon}
    selectedPeriod={billingPeriod}
    formErrors={filterFormErrors(errors, touched)}
    onPurchase={handleSubmit}
  />
);

const UpgradeSubscriptionForm: FC<UpgradeSubscriptionFormProps> = props => (
  <Form
    initialValues={{
      email: props.email,
      coupon: props.coupon,
      billingPeriod: props.selectedPeriod
    }}
    keepDirtyOnReinitialize={true}
    render={renderForm(props)}
    {...props}
  />
);

export default UpgradeSubscriptionForm;
